module.exports = __webpack_public_path__ + "img/cover-bg.0381a1ce.png";